<template>


<Dialog header="Doğrulama Oturum Detayı" 
v-model:visible="$store.state.verifications.showdetailsmodal" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '75vw'}"
:modal="true"
:closable="false"
>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>
<template v-if="!loading">

<div class="grid mt-b">


<div class="col-3 md:col-2">
<p class="font-bold">{{$store.state.languages.lang_phrases.tedarikci}}:</p>
</div>
<div class="col-9 md:col-10">
<p class="">
<router-link class="no-underline text-primary text-sm" :to="{ name: 'Supplier', params: { id:item.supplier.id }}">{{item.supplier.name}}
  </router-link>
</p>
</div>


<div class="col-3 md:col-2">
<p class="font-bold">{{$store.state.languages.lang_phrases.denetci}}:</p>
</div>
<div class="col-9 md:col-10">
<p class="">
<router-link class="no-underline text-primary text-sm" :to="{ name: 'User', params: { id:item.auditor.user.id }}">{{item.auditor.user.name}}
  </router-link>
</p>
</div>

<div class="col-3 md:col-2">
<p class="font-bold">{{$store.state.languages.lang_phrases.oturum_tarihi}}:</p>
</div>
<div class="col-9 md:col-10">
<p class="">
{{ $filters.momentFormat( item.scheduled_at," Do-MM-YYYY dddd HH:mm")}}
</p>
</div>



<div class="col-3 md:col-2">
<p class="font-bold">{{$store.state.languages.lang_phrases.marka}}:</p>
</div>
<div class="col-9 md:col-10">
<p class="">
  <router-link class="no-underline text-primary text-sm" :to="{ name: 'Brand', params: { id:item.flowsupplier.flow.brand.id }}">{{item.flowsupplier.flow.brand.name}}
  </router-link>
</p>
</div>



<div class="col-3 md:col-2">
<p class="font-bold">{{$store.state.languages.lang_phrases.proje}}:</p>
</div>
<div class="col-9 md:col-10">
<p class="">
<router-link class="no-underline text-primary text-sm" :to="{ name: 'Project', params: { id: item.flowsupplier.flow.project.id }}">{{item.flowsupplier.flow.project.name}}
  </router-link>
</p>
</div>

<div class="col-3 md:col-2">
<p class="font-bold">{{$store.state.languages.lang_phrases.akis}}:</p>
</div>
<div class="col-9 md:col-10">
<p class="">
<router-link class="no-underline text-primary text-sm" :to="{ name: 'Flow', params: { id:item.flowsupplier.flow.id }}">{{item.flowsupplier.flow.name}}
  </router-link>
</p>
</div>


<div class="col-3 md:col-2">
<p class="font-bold">{{$store.state.languages.lang_phrases.soru_listesi}}:</p>
</div>
<div class="col-9 md:col-10">
<p class="">
 <router-link class="no-underline text-primary text-sm" :to="{ name: 'Questionlist', params: { id: item.flowsupplier.flow.questionlist.id }}">{{item.flowsupplier.flow.questionlist.name}}
  </router-link>
</p>
</div>






</div>

</template>


<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="close" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>
</template>


</Dialog>

</template>

<script>
export default {

  name: 'ScheduleDetailsModal',

  data () {
    return {
    	loading:true,
    	item:null,
    }
  },
  computed:{
  	selectedevent()
  	{
  		return this.$store.state.verifications.selectedevent
  	}
  },
  watch:{
  	selectedevent(newval)
  	{
  		if(newval)
  		{
  			this.getData(newval)
  		}
  		
  	}
  },
  methods:{
  	close()
  	{
  		this.$store.dispatch('verifications/setShowDetailModal',false) 
  	},
  	async getData(id)
  	{
  		this.loading = await true
  		this.item = await this.generalApiGetWithoutLoader("verification/"+id)
  		await console.log(this.item)
  		this.loading = await false
  	}
  }
}
</script>

<style lang="css" scoped>
</style>